<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="收费配置" subheading="" />
      <!--<a @click="toModifyConfig" v-if="permissionCodes.indexOf('045003001') !== -1">修改</a>-->
      <a @click="toModifyConfig" v-if="permissionCodes.indexOf('045003001') !== -1">修改</a>
    </div>
    <form>
      <div>
        <div class="form-line">
          <div class="line-text">收费标准：</div>
          <div>固定定价</div>
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="line-text">蒸汽单价：</div>
          <div>{{ steamConfigData.steamUnitPrice || '0' }}元/吨</div>
        </div>
      </div>

      <!--      <div>-->
      <!--        <div class="form-line">-->
      <!--          <div class="line-text">冷蒸汽单价：</div>-->
      <!--          <div>{{ steamConfigData.coldUnitPrice || '0' }}元/吨</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </form>
  </div>
</template>

<script>
import { errorHandler } from '../../../utils/errorHandler'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import { api } from '../../api/SteamManagement'
import TextTitle from '../../../components/Text/TextTitle'
import { bus } from '../../../utils/bus'

export default {
  components: {
    TextTitle,
    Breadcrumb,
  },
  name: 'electronic-config',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧蒸汽',
            name: 'steam-over-view',
          },
          {
            value: '收费配置',
          },
        ],
      },
      permissionCodes: '',
      steamConfigData: {
        feeType: '1',
        hotUnitPrice: '0',
        coldUnitPrice: '0',
      },
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
    this.getSteamPayConfig()
  },
  activated() {
    this.getSteamPayConfig()
  },
  methods: {
    toModifyConfig() {
      this.$router.push({
        name: 'steam-config-modify',
      })
    },
    getSteamPayConfig() {
      this.$axios
        .post(api.getSteamPayConfig, {})
        .then((res) => {
          let data = res.data.data
          if (data) {
            this.steamConfigData = data
          }
        })
        .catch(errorHandler('获取收费数据失败'))
    },
  },
}
</script>

<style scoped>
.main_right {
  text-align: left;
}

.flexBox {
  display: flex;
  justify-content: space-between;
}

.flexBox a {
  line-height: 58px;
  margin-right: 40px;
  cursor: pointer;
  color: #00a0e6;
}
.flexBox a:hover {
  color: #06b3ff;
}

form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
form > div {
  display: flex;
  justify-content: flex-start;
}
form > div > div {
  min-width: 320px;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  padding-left: 5px;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 20px 0;
  line-height: 24px;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 120px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/SteamConfig/SteamConfigCenter.vue